<template>
    <div class="content">
      <div class="md-layout">
        <div
          class="
            md-layout-item
            md-small-size-100
            md-medium-size-100
            md-xsmall-size-100
            md-size-100
          ">
          <div>
            <div v-if="isLoading"><LoadingData /></div>
            <div v-else>
              <div class="text-right">
                  <md-button
                    class="md-raised md-primary"
                    @click="addNewAccount()"
                    >Add Virtual Account</md-button
                  >
                </div>
              <div v-if="isEmpty"><EmptyData /></div>
              <div v-else>
                <md-table table-header-color="green">
                  <md-table-row>
                    <md-table-head>S/N</md-table-head>
                    <md-table-head>Account Number</md-table-head>
                    <md-table-head>Account Name</md-table-head>
                    <md-table-head>Bank</md-table-head>
                    <md-table-head>Bank Code</md-table-head>
                    <md-table-head>Meter Number</md-table-head>
                    <md-table-head>Disco</md-table-head>
                    <md-table-head>Used</md-table-head>
                    <md-table-head>Date Created</md-table-head>
                  </md-table-row>

                  <md-table-row v-for="(t, index) in incoming" :key="index">
                    <!-- Name -->
                    <md-table-cell md-label="Name">
                      <p>{{ index + 1 }}</p>
                    </md-table-cell>
                    <!-- Account Name -->
                    <md-table-cell md-label="Name">
                      <p>{{ t.acc_num }}</p>
                    </md-table-cell>
                    <!-- Email Address -->
                    <md-table-cell md-label="Name">{{
                      t.acc_name
                    }}</md-table-cell>
                    <!-- Phone Number -->
                    <md-table-cell md-label="Name">{{
                      t.bank_code
                    }}</md-table-cell>
                    <!-- Role -->
                    <md-table-cell md-label="Role"> {{ t.bank }} </md-table-cell>
                    <!-- Member since -->
                    <md-table-cell md-label="Name">{{
                      t.meter
                    }}</md-table-cell>
                    <!-- Action -->
                    <md-table-cell md-label="Action">
                      {{ t.disco }}
                    </md-table-cell>
                    <md-table-cell md-label="Action">
                      {{ t.used }}
                    </md-table-cell>
                    <md-table-cell md-label="Action">
                      {{ format(t.created_at) }}
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <md-snackbar
        md-position="center"
        :md-duration="6000"
        :md-active.sync="snackBar.show"
        md-persistent
      >
        <span>{{ snackBar.message }}</span>
      </md-snackbar>

      <NewAccountModal
      ref="addNewAccountModal"
    />
    </div>
  </template>

<script>
import format from 'date-fns/format';
import http from '../../../utils/Http.util';
import NewAccountModal from '../modal/newAccountModal.vue';
import EmptyData from '../../../components/EmptyData.vue';
import LoadingData from '../../../components/LoadingData.vue';

export default {
  components: {
    EmptyData,
    LoadingData,
    NewAccountModal,
  },
  mounted() {
    this.getCustomerDetail();
  },
  created() {

  },
  computed: {
    isEmpty() {
      return !this.incoming.length;
    },
  },
  data() {
    return {
      snackBar: {
        show: false,
        message: null,
      },
      incoming: [],
      isLoading: false,
      phone: null,
    };
  },
  methods: {
    format,
    async getCustomerAccounts(state) {
      try {
        if (!state) throw new Error('Unable to Fetch Coustomer Accounts');
        this.isLoading = true;
        const result = await http.authReq(`/dashboard/customers/${this.phone}/virtual-accounts`);
        this.isLoading = false;
        const { data } = result;
        this.incoming = data;
      } catch (err) {
        this.isLoading = false;
        this.snackBar = {
          show: true,
          message: err.response ? err.response.data.message : err.message,
        };
      }
    },
    async getCustomerDetail() {
      this.$store.commit('busyStatus', true);
      try {
        const userID = this.$route.query.queryId;
        const result = await http.authReq(`/dashboard/customers/${userID}`);
        this.phone = result.data.customer.phone;
        this.$store.commit('busyStatus', false);
        this.getCustomerAccounts(true);
      } catch (error) {
        this.$store.commit('busyStatus', false);
        this.getCustomerAccounts(false);
        this.snackBar = {
          show: true,
          message: 'Unable to Get User Detail',
        };
      }
    },
    addNewAccount() {
      this.$refs.addNewAccountModal.phone = this.phone;
      this.$refs.addNewAccountModal.callback = this.getCustomerAccounts;
      this.$refs.addNewAccountModal.onOpen();
    },
  },
};
</script>

  <style>
  .page-btn {
    margin-right: 20px;
    font-size: 20px !important;
  }
  .md-menu-content {
    z-index: 11 !important;
  }
  </style>
